import React from 'react'
import Layout from '../components/layout'
import { TbArrowRight, TbChevronRight } from 'react-icons/tb'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'

const Products = () => {
    return (<Layout pageTitle='Products - Dochase Adx'>
        <div className='lg:max-w-[1440px] mx-auto pt-20 lg:pt-28'>
            <section className='relative inline-block w-full'>
                <StaticImage
                    src="https://res.cloudinary.com/dt4exd1wa/image/upload/v1696332051/dochaseadx/g0nserupeml8t6xdx6xz.png"
                    alt='products'
                    placeholder="blurred"
                    quality="100"
                    className='block max-w-full mx-auto'
                />
                <div className='absolute top-[55%] lg:top-[45%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-[70%] lg:w-[55%]'>
                    <p className='text-white font-bold text-3xl lg:text-8xl text-center'>Products made for everyone</p>
                    <p className='text-white font-medium text-base lg:text-3xl text-center mt-5 lg:mt-11'>Explore a range of meticulously crafted tools designed to enhance your Advertising.</p>
                    <Link className='w-full flex justify-center' to='/#form'>
                        <button className='bg-brand-red text-white lg:py-3 py-1 px-5 lg:px-11 rounded-md font-bold mt-7 lg:mt-14 text-xs lg:text-sm'>Get Started</button>
                    </Link>
                </div>
            </section>

            <section className='my-16 lg:my-32 w-full lg:w-auto lg:mx-[14%] space-y-10'>
                <div className='bg-[#f9253908] pb-16 lg:pb-36 pt-14 lg:pt-28' id='messaging'>
                    <div className='lg:max-w-[1440px] mx-auto'>
                        <div className='mx-[4%] lg:mx-[8%]'>
                            <div className='lg:grid lg:grid-cols-2 lg:gap-8'>
                                <div className='my-auto grid justify-items-start'>
                                    <p className='text-2xl lg:text-5xl font-bold text-[#454444]'>Messaging</p>
                                    <p className='mt-5 lg:mt-9 text-base lg:text-xl'>Deploy marketing and transactional messaging directly to customers on SMS, whatsapp and more. Segment users by income level, age, gender, location, device and much more. Seamlessly deliver targeted messages, promotions, and updates directly to your offline audience’s mobile devices.</p>
                                </div>
                                <StaticImage
                                    src="https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331915/dochaseadx/pqbpg9yynmfqeg8jlpnt.png"
                                    alt='messaging'
                                    placeholder="blurred"
                                    quality="100"
                                    className='lg:w-max'
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='bg-[#00c28b0d] pb-16 lg:pb-36 pt-14 lg:pt-28' id='chatbot'>
                    <div className='lg:max-w-[1440px] mx-auto'>
                        <div className='mx-[4%]'>
                            <div className='lg:grid lg:grid-cols-2 lg:gap-8'>
                                <StaticImage
                                    src="https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331875/dochaseadx/fgvl5qwfidmjwcirhxqj.png"
                                    alt='products'
                                    placeholder="blurred"
                                    quality="100"
                                    className='lg:w-max'
                                />
                                <div className='my-auto grid justify-items-end text-end mt-8 lg:mt-0'>
                                    <p className='text-2xl lg:text-5xl font-bold text-[#454444]'>Chatbot</p>
                                    <p className='mt-5 lg:mt-9 text-base lg:text-xl'>Discover how our chatbot can help you drive sales, leads, and site traffic by engaging customers in real-time conversations. Respond to customers' requests and automate conversation to improve your services to larger customers.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='bg-[#f9253908] pb-16 lg:pb-36 pt-14 lg:pt-28' id='native-ads'>
                    <div className='lg:max-w-[1440px] mx-auto'>
                        <div className='mx-[4%] lg:mx-[8%]'>
                            <div className='lg:grid lg:grid-cols-2 lg:gap-8'>
                                <div className='my-auto grid justify-items-start'>
                                    <p className='text-2xl lg:text-5xl font-bold text-[#454444]'>Native Ads</p>
                                    <p className='mt-5 lg:mt-9 text-base lg:text-xl'>Tell stories that connect by leveraging adverts that look like stories to promote and drive signups. Native ads offer a unique opportunity to connect authentically, ensuring your brand message is heard amidst the noise of the digital landscape.</p>
                                </div>
                                <StaticImage
                                    src="https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331936/dochaseadx/mumjytvt61oiq4ujizuv.png"
                                    alt='products'
                                    placeholder="blurred"
                                    quality="100"
                                    className='lg:w-max'
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='bg-[#00c28b0d] pb-16 lg:pb-36 pt-14 lg:pt-28' id='click-to-whatsapp'>
                    <div className='lg:max-w-[1440px] mx-auto'>
                        <div className='mx-[4%]'>
                            <div className='lg:grid lg:grid-cols-2 lg:gap-8'>
                                <StaticImage
                                    src="https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331763/dochaseadx/aygrnwbo4dp9nufxmzmd.png"
                                    alt='products'
                                    placeholder="blurred"
                                    quality="100"
                                    className='lg:w-max'
                                />
                                <div className='my-auto grid justify-items-end text-end mt-8 lg:mt-0'>
                                    <p className='text-2xl lg:text-5xl font-bold text-[#454444]'>Click to Whatsapp</p>
                                    <p className='mt-5 lg:mt-9 text-base lg:text-xl'>Get leads, engages users and build audience with user journeys from banners to whatsapp chat. When users click adverts they initiate whatsapp conversation. This is used for generating direct engagements, leads and building a community of users.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='bg-[#f9253908] pb-16 lg:pb-36 pt-14 lg:pt-28' id='click-to-ussd'>
                    <div className='lg:max-w-[1440px] mx-auto'>
                        <div className='mx-[4%] lg:mx-[8%]'>
                            <div className='lg:grid lg:grid-cols-2 lg:gap-8'>
                                <div className='my-auto grid justify-items-start'>
                                    <p className='text-2xl lg:text-5xl font-bold text-[#454444]'>Click to USSD</p>
                                    <p className='mt-5 lg:mt-9 text-base lg:text-xl'>Offer users a direct pathway to access your services through a simple and intuitive USSD interface. When a user clicks the ads, they initiate a USSD session on your platform, thereby generating activities and user engagements.</p>
                                    <button className='text-brand-red border-2 border-brand-red py-3 px-5 rounded-md font-bold text-xs lg:text-sm flex mt-5 lg:mt-10'>Learn more about this service <TbChevronRight className='w-4 h-4 my-auto ml-2' /></button>
                                </div>
                                <StaticImage
                                    src="https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331763/dochaseadx/aygrnwbo4dp9nufxmzmd.png"
                                    alt='products'
                                    placeholder="blurred"
                                    quality="100"
                                    className='lg:w-max'
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='bg-[#00c28b0d] pb-16 lg:pb-36 pt-14 lg:pt-28' id='video-ads'>
                    <div className='lg:max-w-[1440px] mx-auto'>
                        <div className='mx-[4%]'>
                            <div className='lg:grid lg:grid-cols-2 lg:gap-8'>
                                <StaticImage
                                    src="https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331763/dochaseadx/aygrnwbo4dp9nufxmzmd.png"
                                    alt='products'
                                    placeholder="blurred"
                                    quality="100"
                                    className='lg:w-max'
                                />
                                <div className='my-auto grid justify-items-end text-end mt-8 lg:mt-0'>
                                    <p className='text-2xl lg:text-5xl font-bold text-[#454444]'>Video Ads</p>
                                    <p className='mt-5 lg:mt-9 text-base lg:text-xl'>Use compelling video ads to seize attention and resonate with your audience's emotions. With the power of sight, sound, and motion, deliver your message vividly, whether on social media, streaming platforms, or websites.</p>
                                    <button className='text-brand-red border-2 border-brand-red py-3 px-5 rounded-md font-bold text-xs lg:text-sm flex mt-5 lg:mt-10'>Learn more about this service <TbChevronRight className='w-4 h-4 my-auto ml-2' /></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='grid'>
                    <Link to='/#form' className='mx-auto'>
                        <button className='bg-brand-red text-white py-1.5 lg:py-3 px-6 lg:px-11 rounded-md font-bold mt-14 lg:mt-28 text-xs lg:text-sm max-w-fit mx-auto'>Get Started</button>
                    </Link>
                    <p className='text-center text-[#4F4F4F] text-base lg:text-xl mt-7 lg:mt-14'>Contact one of our experts for help that is specific to you.</p>
                    <a href='mailto:info@dochase.com' className='flex mx-auto text-brand-red mt-5 lg:mt-9 text-xs lg:text-sm font-bold'>Contact an expert <TbArrowRight className='my-auto w-3 h-3 ml-2' /></a>
                </div>
            </section>
        </div>
    </Layout>
    )
}

export default Products